import type { Word } from '@shared/types';

/** Строка конструктора — слово в одной части речи (user_card_state), а в тренировку она
 *  приносит по карточке на каждый отмеченный смысл (cluster: «гроздь», «группа» — две).
 *  Счётчики и лимит считают карточки, иначе «8 из 8» при 11 созданных (2026-10-06). */
export type CardWeight = (stateId: string) => number;

export const cardShows = (card: Word): number => Math.max(1, card.sessionSenseIds?.length ?? 0);

/** Переводы карточек строки: главный перевод каждого отмеченного смысла. Ничего не
 *  отмечено — бэк отдаёт основной смысл; без значений (старые данные) — card.ru. */
export function sessionTranslations(card: Word): string[] {
  const meaning = card.meanings?.find((item) => item.id === card.meaningId);
  const texts = (card.sessionSenseIds ?? [])
    .map((id) => meaning?.senses.find((sense) => sense.id === id)?.translations[0]?.text)
    .filter((text): text is string => !!text);
  return texts.length ? texts : [card.ru];
}

export function totalWeight(ids: Iterable<string>, weight: CardWeight): number {
  let total = 0;
  for (const id of ids) total += weight(id);
  return total;
}

/** Строки по порядку, пока карточек не больше limit: не влезающая пропускается, следующая
 *  ещё может влезть. */
export function takeUpTo(ids: Iterable<string>, limit: number, weight: CardWeight): string[] {
  const picked: string[] = [];
  let total = 0;
  for (const id of ids) {
    if (total >= limit) break;
    const size = weight(id);
    if (total + size > limit) continue;
    picked.push(id);
    total += size;
  }
  return picked;
}
